import { API_URL } from '../../config';

// Application-owned adapter: this file is outside the shared formPlugins copy.
export const FORM_API_URL = API_URL;
